import React from 'react'
import { PlayerRow, StatPickerGroupProps } from './utils/types.ts'
import PitchArsenalDropdown from './PitchArsenalDropdown.tsx'

function getGroupedArsenalStats(arsenalStats: (keyof PlayerRow)[]) {
    return arsenalStats.reduce((acc, stat) => {
        const prefix = stat.split('_')[0]
        if (!acc[prefix]) acc[prefix] = []
        acc[prefix].push(stat)
        return acc
    }, {} as Record<string, string[]>)
}

export default function StatPickerGroup({
    keyName,
    sectionTitle,
    statsInGroup,
    expandedPitches,
    searchFilter,
    selectedPlayers,
    togglePitchDrawer,
    renderStatNode,
}: StatPickerGroupProps) {
    return (
        <div key={keyName}>
            <div className="stat-picker-scroll-subheader">{sectionTitle}</div>

            {keyName === 'pitch_arsenal'
                ? (() => {
                      const pitchGroups = getGroupedArsenalStats(statsInGroup)

                      return Object.entries(pitchGroups).map(
                          ([pitch, pitchStats]) => {
                              const isExpanded =
                                  expandedPitches.includes(pitch) ||
                                  searchFilter !== ''

                              const runValueKey =
                                  `${pitch}_percent_rank_pitch_usage` as keyof PlayerRow
                              const pitchersWithPitch = selectedPlayers.filter(
                                  (p) =>
                                      p[runValueKey] !== null &&
                                      p[runValueKey] !== undefined &&
                                      p.grouping_cat === 'Pitcher'
                              )

                              const seenIds = new Set()
                              const uniquePlayers = pitchersWithPitch.filter(
                                  (player) => {
                                      if (seenIds.has(Number(player.id))) {
                                          return false
                                      }
                                      seenIds.add(Number(player.id))
                                      return true
                                  }
                              )

                              return (
                                  <PitchArsenalDropdown
                                      key={pitch}
                                      pitch={pitch}
                                      pitchStats={pitchStats}
                                      pitchersWithPitch={uniquePlayers}
                                      isExpanded={isExpanded}
                                      togglePitchDrawer={togglePitchDrawer}
                                      renderStatNode={renderStatNode}
                                  />
                              )
                          }
                      )
                  })()
                : statsInGroup.map((stat) => renderStatNode(stat))}
        </div>
    )
}
